export const DEFAULTQUERIES = {
  CMS_EDITOR: '?track=&&topic=&&make=&&component=',
};
export const CMS_MAIN = '/cms/main';
export const CMS_FACILITATOR = '/cms/facilitator';
export const CMS_GUIDE = '/cms/guide';
export const CMS_TOURNAMENT = '/cms/tournament';
